import React from "react";

export default function SctModal({ isOpen, onClose, imgUrl }) {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            aria-hidden={!isOpen}
        >
            <div className="bg-white rounded-lg shadow-lg max-w-2xl w-full p-6">
                {/* Header */}
                <div className="flex justify-end items-center pb-3">
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>

                {/* Body */}
                <div className="mt-4 space-y-4 flex justify-center">
                    <img
                        src={imgUrl}
                        alt="Screenshot"
                        style={{ width: '39rem', height: '20rem' }}
                    />
                </div>
            </div>
        </div>
    );
}
